//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const ADDON_ORDER = [
  'unlimited-e-signing-pt',
  'unlimited-contracts-pt',
  'unlimited-template-access-pt',
  'extra-users-pt',
  'workspace-viewer-pt',
]

export default {
  props: {
    priceList: {
      type: Object,
      required: true,
    },
    isMonthly: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      showAll: false,
    }
  },
  computed: {
    periodUnit () {
      return this.isMonthly ? 'month' : 'year'
    },
    headings () {
      return this.priceList.items.map(item => ({ title: item.title, price: item.prices.find(price => price.period_unit === this.periodUnit) }))
    },
    allFeatures () {
      return this.priceList?.data?.features
    },
    visibleFeatures () {
      return this.allFeatures.slice(0, this.showAll ? undefined : 5)
    },
    addonRows () {
      return (this.priceList?.addons ?? []).map(addon => ({
        id: addon.addon_id,
        ...this.getAddonTitleAndDescription(addon),
        cols: this.priceList.items.map(item => ({
          text: this.getAddonPriceText(addon, item),
        })),
      })).sort((a, b) => ADDON_ORDER.indexOf(a.id) - ADDON_ORDER.indexOf(b.id))
        .filter(addon => ADDON_ORDER.includes(addon.id))
    },
    rows () {
      return this.visibleFeatures.map(feature => ({
        feature,
        cols: this.priceList.items.map(item => ({
          id: item.id,
          feature: [...(item.data.features?.[this.periodUnit] ?? item.data.features)].find(({ id: featureId }) => featureId === feature.id),
        }))
      }))
    }
  },
  methods: {
    getAddonTitleAndDescription (addon) {
      switch (addon.addon_id) {
        case 'extra-users-pt':
          return {
            title: this.$t('priceListTable.addons.user-license.title'),
            description: this.$t('priceListTable.addons.user-license.description'),
          }
        case 'workspace-viewer-pt':
          return {
            title: this.$t('priceListTable.addons.viewer-license.title'),
            description: this.$t('priceListTable.addons.viewer-license.description'),
          }
        case 'unlimited-template-access-pt':
          return {
            title: this.$t('priceListTable.addons.unlimited-template-access.title'),
            description: this.$t('priceListTable.addons.unlimited-template-access.description'),
          }
        case 'unlimited-contracts-pt':
          return {
            title: this.$t('priceListTable.addons.unlimited-contracts.title'),
            description: this.$t('priceListTable.addons.unlimited-contracts.description'),
          }
        case 'unlimited-e-signing-pt':
          return {
            title: this.$t('priceListTable.addons.unlimited-e-signing.title'),
            description: this.$t('priceListTable.addons.unlimited-e-signing.description'),
          }
      }
    },
    getAddonPriceText (addon, plan) {
      const price = addon.prices.find(price => price.period_unit === this.periodUnit)
      const isStarterPlan = plan.prices.some(({ id }) => id.startsWith('pricing-test-starter') || (this.$country.isSweden() && id.startsWith('2025-starter')))

      if (!['extra-users-pt', 'workspace-viewer-pt'].includes(addon.addon_id) && !isStarterPlan) {
        return [this.$t('priceListTable.included')]
      }

      return addon.addon_id === 'extra-users-pt'
        ? [`+${this.$n(price.monthly_price / 100, 'currency')}`, this.$t('priceListTable.addons.user-license.entity'), this.$t('priceListTable.month')]
        : addon.addon_id === 'workspace-viewer-pt'
          ? [`+${this.$n(price.monthly_price / 100, 'currency')}`, this.$t('priceListTable.addons.viewer-license.entity'), this.$t('priceListTable.month')]
          : [`+${this.$n(price.monthly_price / 100, 'currency')}`, this.$t('priceListTable.month')]
    }
  }
}
